import { fromJS } from 'immutable'
import {
  POSITION_GET_REQUEST,
  POSITION_GET_SUCCESS,
  POSITION_GET_FAILURE,
  POSITION_GET_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case POSITION_GET_REQUEST:
      return state
        .set('isFetching', true)
    case POSITION_GET_SUCCESS:
      return state
        .set('position', fromJS(action.payload.position))
        .set('isFetching', false)
    case POSITION_GET_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case POSITION_GET_RESET:
      return state
        .delete('position')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/position/position-get-reducer.js